import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { Table } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import { studyOtherSettingsServices } from "../../../../../APIServices/studyOtherSettingsServices";
import { useParams } from "react-router";
import UseToggle from "../../../../../Hooks/UseToggle";
import NoConditionalForm from "../FormReport/NoConditionalForm";
import InvestigatorSignature from "./InvestigatorSignature";
import { formReportServices } from "../../../../../APIServices/formReportServices";

const PrintSubjectFormReport = ({
  formData,
  subjectName,
  totalOptionId,
  handleNumberChange,
  handleCustomNumberChange,
  handleTextChange,
  handleCustomTextChange,
  handleDateChange,
  handleCustomDateChange,
  handleTimeChange,
  handleCustomTimeChange,
  handleTextareaChange,
  handleDropdownRadioChange,
  handleCustomDropdownRadioChange,
  handleRangeScoreChange,
  handleScaleChange,
  handleUploadChange,
  handleCheckboxChange,
  handleCustomCheckboxChange,
  convertTo24,
}) => {
  const GeneratedDate = moment(new Date()).format("DD-MMM-YYYY | HH:mm:ss");
  const { studyId } = useParams();
  const { setToggle } = UseToggle()
  const signatureRef = useRef(null);
  const [errorValidation, setErrorValidation] = useState(false)
  const [hideShowSignature, setHideShowSignature] = useState(false)
  const [hideShowInvestigatorSignature, setHideShowInvestigatorSignature] = useState(false)
  const [reportHeaders, setReportHeaders] = useState([]);
  const [reportFooters, setReportFooters] = useState([]);
  const [reportLogo, setReportLogo] = useState("");
  const componentRef = useRef();
  const getReportStudyMetadataData = async () => {
    let data = await formReportServices.getReportStudyMetadataData(studyId)
    let reportData = data?.data || []
    let headerData = reportData?.find(item => item.type === "header")?.headerData || []
    let footerData = reportData?.find(item => item.type === "footer")?.footerData || []
    let logoData = reportData?.find(item => item.type === "logo")
    setReportHeaders(headerData)
    setReportFooters(footerData)
    setReportLogo(logoData)
  }

  useEffect(() => {
    if (hideShowInvestigatorSignature && signatureRef.current) {
      signatureRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [hideShowInvestigatorSignature]);

  useEffect(() => {
    getReportStudyMetadataData();
  }, []);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `${subjectName} Report`,
  });

  const valueRanderFunction = (totalDataEntry) => (id) => {
    return totalDataEntry?.find(item => item.fieldId === id) || "";
  };

  return (
    <>
      <div className="border-bottom p-2 ps-4 bg-light">
        <div className="hstack justify-content-between" style={{ height: 30 }}>
          <h6 className="fw-bold mb-0">
            <i className="fa-solid fa-file-prescription me-2"></i>
            {subjectName}
          </h6>
          <div className="hstack gap-2">
            <button
              className="updateProfile hstack text-nowrap"
              onClick={() => setHideShowInvestigatorSignature(!hideShowInvestigatorSignature)}
              title={hideShowInvestigatorSignature ? "Show Investigator Signature" : "Hide Investigator Signature"}
            >
              {!hideShowInvestigatorSignature ? "Show Investigator Signature" : "Hide Investigator Signature"}
            </button>
            <button
              className={`updateProfile hstack text-nowrap`}
              onClick={() => setHideShowSignature(!hideShowSignature)}
              title={hideShowSignature ? "Show Signature" : "Hide Signature"}
            >
              {!hideShowSignature ? "Show Signature" : "Hide Signature"}
            </button>
            <button
              className={`updateProfile hstack text-nowrap`}
              onClick={handlePrint}
              title="Print Report"
            >
              Print Report
            </button>
          </div>
        </div>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 229px)" }}>
        <div ref={componentRef}>
          {formData?.map((event, eventIndex) => (
            (event?.formList || [])?.map((form, formIndex) => (
              <React.Fragment key={form?.id ?? formIndex}>
                <div className="page-break" />
                <Table key={`${eventIndex}_${formIndex}`} className="m-0">
                  {/* <thead className="position-sticky top-0 z-1">
                    <tr>
                        <th colSpan={100} className="p-0 border-0">
                            <div className="crfHeader headPrint">
                                 <div className="crfTop hstack justify-content-between text-white">
                                    <div className="gap-3 hstack">
                                        <img src={reportLogo?.logo || "https://www.largeherds.co.za/wp-content/uploads/2024/01/logo-placeholder-image.png"} alt="Company Logo" style={{ width: reportLogo?.width || 80, height: reportLogo?.height || 80 }} />  
                                        <div>
                                            {reportHeaders?.length > 0 && reportHeaders?.map((item, index) => ( <p key={index} className="m-0 fw-bold" style={{ fontSize: 12 }}>{item?.text}</p> ))}
                                            <p className="m-0 fw-bold">{form?.formName}</p> <small className="m-0">SDTM LB-aligned eCRF · Electronic Case Report Form</small>
                                        </div>
                                    </div>
                                </div>
                                <div className="crfInfoRow d-grid">
                                    <div className="crfCell">
                                        <small className="m-0 text-white opacity-75" style={{ fontSize: 11 }}>FORM ID</small>

                                        <p className="m-0 fw-bold text-white" style={{ fontSize: 12 }}>{form?.formName}</p>
                                    </div>

                                    <div className="crfCell">
                                        <small className="m-0 text-white opacity-75" style={{ fontSize: 11 }}>VERSION</small>

                                        <p className="m-0 fw-bold text-white" style={{ fontSize: 12 }}>V.{form?.formVersion}</p>
                                    </div>

                                    <div className="crfCell">
                                        <small className="m-0 text-white opacity-75" style={{ fontSize: 11 }}>Generated On:</small>

                                        <p className="m-0 fw-bold text-white" style={{ fontSize: 12 }}>{GeneratedDate}</p>
                                    </div>
                                </div>

                                <div className="crfInfoRow light d-grid">

                                    <div className="crfCell">
                                        <small className="m-0 text-muted">SUBJECT</small>

                                        <p className="m-0 fw-bold" style={{ fontSize: 12 }}>{subjectName || '-'}</p>
                                    </div>

                                    <div className="crfCell">
                                        <small className="m-0 text-muted">VISIT</small>

                                        <p className="m-0 fw-bold" style={{ fontSize: 12 }}>{event?.eventName || '-'}</p>
                                    </div>
                                {event?.timePointId && 
                                    <div className="crfCell">
                                        <small className="m-0 text-muted">TIME POINT ID</small>

                                        <p className="m-0 fw-bold" style={{ fontSize: 12 }}>{event?.timePointId || '-'}</p>
                                    </div>
                                }
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead> */}
                <thead className="position-sticky top-0 z-1">
                    <div className="headPrint">
                      <div className="hstack justify-content-between py-3">
                        <div>
                          {reportHeaders?.length > 0 && reportHeaders?.map((item, index) => (
                            <p key={index} className="m-0 fw-bold fontSize12">{item?.text}</p>
                          ))}
                          <p className="m-0 fw-bold fontSize12">Subject Id: {subjectName}</p>
                          <p className="m-0 fw-bold fontSize12">Event Name: {event?.eventName}</p>
                          {event?.timePointId && <p className="m-0 fw-bold fontSize12">Time Point Id: {event?.timePointId}</p>}
                          <p className="m-0 fw-bold fontSize12">Form Name: {form?.formName}</p>
                          <p className="m-0 fw-bold fontSize12">Form Version: V{form?.formVersion}</p>
                          <p className="m-0 fw-bold fontSize12">Generated On: {GeneratedDate}</p>
                        </div>
                        <img src={reportLogo?.logo || ""} alt="Company Logo" style={{ width: reportLogo?.width || 150, height: reportLogo?.height || 80 }} />
                      </div>
                    </div>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border-0 p-0">
                        <NoConditionalForm
                          formFields={form?.formFields || []}
                          setErrorValidation={setErrorValidation}
                          totalOptionId={totalOptionId}
                          valueRanderFunction={valueRanderFunction(form?.dataEntry)}
                          handleNumberChange={handleNumberChange}
                          handleCustomNumberChange={handleCustomNumberChange}
                          handleTextChange={handleTextChange}
                          handleCustomTextChange={handleCustomTextChange}
                          handleDateChange={handleDateChange}
                          handleCustomDateChange={handleCustomDateChange}
                          handleTimeChange={handleTimeChange}
                          handleCustomTimeChange={handleCustomTimeChange}
                          handleTextareaChange={handleTextareaChange}
                          handleDropdownRadioChange={handleDropdownRadioChange}
                          handleCustomDropdownRadioChange={handleCustomDropdownRadioChange}
                          handleRangeScoreChange={handleRangeScoreChange}
                          handleScaleChange={handleScaleChange}
                          handleUploadChange={handleUploadChange}
                          handleCheckboxChange={handleCheckboxChange}
                          handleCustomCheckboxChange={handleCustomCheckboxChange}
                          convertTo24={convertTo24}
                          setToggle={setToggle}
                          DBPSignatureBy={form?.DBPSignatureBy}
                          DBPQualityCheck={form?.DBPQualityCheck}
                          DBPSignatureDT={form?.DBPSignatureDT}
                          DBPSignatureCode={form?.DBPSignatureCode}
                          DVSignatureCode={form?.DVSignatureCode}
                          DVQualityCheck={form?.DVQualityCheck}
                          DVSignatureBy={form?.DVSignatureBy}
                          DVSignatureDT={form?.DVSignatureDT}
                          footer={hideShowSignature}
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </React.Fragment>
            ))
          ))}
          <div className="page-break" />
          {hideShowInvestigatorSignature && (
            <div ref={signatureRef}>
              <InvestigatorSignature />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PrintSubjectFormReport;
